import type { SeriesPeriod } from "@nexus/widget-kit";

export const CDNSA_ACCOUNT_WATERFALL_CONTRACT = {
  name: "cdnsa-account-waterfall",
  version: 1,
} as const;

export interface AccountWaterfallPoint {
  day: string;
  accounts: number | null;
  previous_accounts: number | null;
  new_accounts: number | null;
  lost_accounts: number | null;
}

export interface CdnsaAccountWaterfallData {
  points: AccountWaterfallPoint[];
  period?: SeriesPeriod | null;
}
